<template>
    <div>
        <div class="flex items-end border-b-4 border-black py-2 mt-8">
            <template v-if="hasMultiplePages">
                <h2
                    class="flex-1 text-2xl">
                    <template v-if="item.title">
                        {{ item.title }}
                    </template>
                    <template v-else>
                        {{ $t('(page name not set)') }}
                    </template>
                </h2>
                <div class="w-24 text-right text-70">
                    <template
                        v-if="resource.template.display_score && typeof(item.percentage) !== 'undefined' && item.percentage !== null">
                        <!-- {{ item.score }} / {{ item.max_score }} -->
                        {{ $n(item.percentage/100, 'scorePercentage') }}
                    </template>
                </div>
            </template>
        </div>
        <SubItems
            :items="item.items"
            :resource="resource"
        />
    </div>
</template>

<script>
    import SubItems from '@/components/InspectionReport/Items/SubItems';

    export default {
        name: 'Page',
        components: { SubItems },
        props: {
            item: {
                type: Object,
                required: true,
            },
            resource: {
                type: Object,
                default: null,
            },
        },

        computed: {
            hasMultiplePages() {
                return this.resource.form.items.length > 2;
            },
            userLocale() {
                return this.$store.getters['authentication/user'].locale;
            },
        },
    };
</script>
